import React, { useContext, useEffect, useState } from 'react';
import css from './StoreView.module.scss';
import StoreSlider from '../components/StoreSlider/StoreSlider';
import StoreProductsGrid from '../components/StoreProductsGrid/StoreProductsGrid';
// import Reviews from '../product/GT/ProductMain/components/Reviews/Reviews';
import T from '../../../common/components/T';
import { getMemoizedData } from '../../../common/utils/memo';
import UserContext, { UserProfileContext } from '../../../common/utils/getContext';

const StoreView = ({ banners }) => {
    const { userToken, lang, storageLoaded, localization } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);

    const [products, setProducts] = useState(null);

    useEffect(() => {
        if ((userToken && !profileData) || !storageLoaded || !localization?.currency) return;
        const country_id = profileData?.country?.geoname_id;
        const currency = profileData?.currency?.code;

        getMemoizedData(
            `/api/v1/shop/products?include=media,special_statuses,properties&page[size]=999${
                country_id ? `&filter[country_id]=${country_id}` : ''
            }`,
            userToken,
            lang,
            userToken && currency ? currency : localization?.currency
        ).then(setProducts);
    }, [userToken, lang, localization?.currency, profileData, storageLoaded]);

    const just_products = products?.data?.filter((product) => product.type === 'product');
    const just_sets = products?.data?.filter((product) => product.type === 'set');

    return (
        <div className={css.storeWrapper}>
            <div className={css.container}>
                <StoreSlider products={products} banners={banners?.data} />
            </div>
            <div className={css.storeComponents}>
                <div className={css.container}>
                    <StoreProductsGrid products={just_products} />
                </div>
                <div className={css.container}>
                    <StoreProductsGrid
                        products={just_sets}
                        title={<T textName='business_sets' defaultStr='Бизнес комплекты' page='/store' />}
                        lightTitle={'Business'}
                    />
                </div>
            </div>
            <div style={{ 'margin-bottom': '2rem' }}></div>
            {/*<div className={css.reviews}>*/}
            {/*    <Reviews isMainStore={true} reviews={reviews} />*/}
            {/*</div>*/}
        </div>
    );
};
export default StoreView;
